import React from 'react';

const SupportIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <title />

    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-251.000000, -207.000000)">
        <g transform="translate(251.000000, 207.000000)">
          <rect
            fill="#FFFFFF"
            fillOpacity="0.01"
            fillRule="nonzero"
            height="24"
            width="24"
            x="0"
            y="0"
          />

          <path d="M18,16 C20.20915,16 22,14.20915 22,12 C22,9.79085 20.20915,8 18,8" />

          <path
            d="M18,16 L18,16 C20.20915,16 22,14.20915 22,12 C22,9.79085 20.20915,8 18,8"
            stroke="#212121"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />

          <path d="M6,8 C3.79086,8 2,9.79085 2,12 C2,14.20915 3.79086,16 6,16" />

          <path
            d="M6,8 C3.79086,8 2,9.79085 2,12 C2,14.20915 3.79086,16 6,16 L6,16"
            stroke="#212121"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />

          <path
            d="M6,16 L6,15.75 L6,14.5 L6,12 L6,8 C6,4.68629 8.6863,2 12,2 C15.3137,2 18,4.68629 18,8 L18,16 C18,19.3137 15.3137,22 12,22"
            stroke="#212121"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SupportIcon;
